import { useSetAtom } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';

import { gracefullySetAllMessagesRead } from '../../session/chat/utils';
import {
  currentConversationAtom,
  currentConversationSidAtom,
  unreadMessageCountByConversationSidAtom,
} from '../../session/state';
import { toast } from '../../toasts';
import { ProviderDrawerState, drawerStateAtom } from '../state';
import { getToastTagForConversation } from './useShowNewMessageToastCallback';

export function useOpenConversationCallback() {
  const setDrawerState = useSetAtom(drawerStateAtom);
  const setCurrentConversationSid = useSetAtom(currentConversationSidAtom);
  const setUnreadMessageCount = useSetAtom(unreadMessageCountByConversationSidAtom);
  const getCurrentConversation = useAtomCallback(useCallback((get) => get(currentConversationAtom), []));

  return useCallback(
    (
      conversationKind: ProviderDrawerState.WAITING_ROOM_CHAT | ProviderDrawerState.SESSION_CHAT,
      conversationSid?: string,
    ) => {
      if (conversationSid) {
        // Dismiss any toasts for this conversation as well.
        toast.closeByTag(getToastTagForConversation(conversationSid));
      }
      setDrawerState(conversationKind);
      if (!conversationSid) return;
      setCurrentConversationSid(conversationSid);
      setUnreadMessageCount((prev) => ({ ...prev, [conversationSid]: 0 }));

      gracefullySetAllMessagesRead(getCurrentConversation());
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
}
